/**
 * Joins first and last name into a trimmed full name, gracefully handling missing parts.
 * @util
 * @__NO_SIDE_EFFECTS__
 */
export function getFullName(firstName, lastName) {
    let fullName = '';
    if (firstName) {
        fullName += firstName.trim();
    }
    if (lastName) {
        fullName += ' ' + lastName.trim();
    }
    return fullName.trim();
}
//# sourceMappingURL=getFullName.js.map